import { singangeApi } from '../../../store/apimiddleware';
// Define a service using a base URL and expected endpoints
export const signageApiSlice = singangeApi
    .enhanceEndpoints({
    addTagTypes: ['Signage'],
})
    .injectEndpoints({
    endpoints: (build) => ({
        getSignages: build.query({
            query: () => ({
                url: 'signages',
                method: 'get',
                data: null,
                params: {},
                headers: {},
            }),
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSignagesQuery } = signageApiSlice;
